export interface AttachmentConstructorData {
  dateCreated: ISODateString
  file: string
  id: number
  length: number
  mimetype: string
  name: string
  uuid: uuid
}

export class Attachment {
  dateCreated: ISODateString
  file: string
  id: number
  length: number
  mimetype: string
  name: string
  uuid: uuid

  constructor(data: AttachmentConstructorData) {
    this.dateCreated = data.dateCreated
    this.file = data.file
    this.id = data.id
    this.length = data.length
    this.mimetype = data.mimetype
    this.name = data.name
    this.uuid = data.uuid
  }
}
